import { DriverStateModel, RegistrationState } from './../../registration/state/registration.state';
import { Component, OnInit } from '@angular/core';
import { ProfilePicture } from 'src/app/shared/models/profile-picture.model';
import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { Store } from '@ngxs/store';
import { ProfileService } from 'src/app/profile/profile.service';
import { first, onErrorResumeNext, tap, finalize } from 'rxjs/operators';
import { Action } from 'src/app/loads-shared/action';
import { AppService } from 'src/app/app.service';
import { PROFILE_INCOMPLETE_STATUS } from 'src/app/shared/services/driver-api.service';

const INCOMPLETE_STATUS_MSG = 'COMPLETE YOUR PROFILE';
const REVIEW_STATUS_MSG = 'PROFILE UNDER REVIEW';

@Component({
    selector: 'app-driver-id-card',
    templateUrl: './driver-id-card.component.html',
    styleUrls: ['./driver-id-card.component.scss'],
    standalone: false
})
export class DriverIdCardComponent implements OnInit {
  driverPicture: string;
  driverName: string;
  driverId: string;
  profileCompleted = false;
  actions: Action[];
  loading: boolean;
  showNavBar: boolean = true;

  private driver: DriverStateModel;
  private profilePicture: ProfilePicture = new ProfilePicture();

  constructor(
    private readonly registrationService: RegistrationService,
    private readonly store: Store,
    private readonly profileService: ProfileService,
    private readonly appService: AppService
  ) {
    this.driverName = '';
    this.actions = [];
  }

  ngOnInit() {
    this.loading = true;
    this.registrationService
      .loadDriver()
      .pipe(
        first(),
        tap(() => {
          this.driver = this.store.selectSnapshot(RegistrationState.driver);
          if (this.driver && this.driver.firstName && this.driver.lastName) {
            this.driverName = `${this.driver.firstName} ${this.driver.lastName}`;
          } else {
            this.driverName = 'Driver Name';
          }
          this.driverId = this.driver.driverID;
        }),
        onErrorResumeNext(this.registrationService.loadProfilePicture()),
        tap(() => {
          this.profilePicture = this.store.selectSnapshot(RegistrationState.profilePicture);

          if (this.profilePicture && this.profilePicture.fileUrl) {
            this.driverPicture = this.profilePicture.fileUrl;
          }
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(() => {
        this.profileCompleted = this.profileService.isProfileCompleted();
      });
    if (!this.profileCompleted) {
      this.createActionFromStatus();
    }
    if (this.appService.isNativeApp) {
      this.showNavBar = false;
    }
  }

  onNavigateToProfile() {
    this.registrationService.navigateToProfile();
  }

  private createCompleteProfileLink(msg_name): Action {
    return {
      name: msg_name,
      action: (data: any) => this.onNavigateToProfile(),
      disabled: false,
      color: 'clear_load'
    } as Action;
  }

  private createActionFromStatus(): void {
    const driver = this.store.selectSnapshot(RegistrationState.driver);

    if (driver && driver.identityStatus) {
      if (driver.identityStatus.toUpperCase() === PROFILE_INCOMPLETE_STATUS.toUpperCase()) {
        this.actions.push(this.createCompleteProfileLink(INCOMPLETE_STATUS_MSG));
      } else {
        this.actions.push(this.createCompleteProfileLink(REVIEW_STATUS_MSG));
      }
    }
  }
}
